import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { Key, ReactElement, JSXElementConstructor, ReactFragment, ReactPortal } from 'react';
import { useState } from "react";
import TablePagination from '@mui/material/TablePagination';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.table.header,
      color: theme.palette.table.headerText,
      padding:"5px"
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      padding:"5px"
    },
    '&:first-of-type': {
      whiteSpace: "nowrap",
    },
    '&.gray': {
      backgroundColor: theme.palette.table.header
    },
    '&.desc': {
      maxWidth: "600px",
      whiteSpace: "normal",
      width: "70%"
    },
}));

const StyledTableCellFooter = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
      backgroundColor: theme.palette.table.footer,
      fontSize: 14,
      padding:"5px",
      color: theme.palette.table.footerText,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.common.white,
    },
    '&:last-child td, &:last-child th': {
      border: 0,
    },
}));

const TimelogTable= (props: { data: any; user: any; totalHours: string; }) => {

    const { data, user, totalHours } = props;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
      console.log(event);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };

        return (
            <>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={3} sx={{ backgroundColor: "table.userHeader", color: "table.headerText", fontSize: 16, fontWeight: 600, padding: "8px 5px" }}>{user}</TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>Description</StyledTableCell>
                    <StyledTableCell align="right">Duration</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {(() => {
                  return data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row: { id: Key | null | undefined; date: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | ReactFragment | ReactPortal | null | undefined; description: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | ReactFragment | ReactPortal | null | undefined; duration: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | ReactFragment | ReactPortal | null | undefined; }) => (
                    <StyledTableRow key={row.id}>
                    <StyledTableCell>{row.date}</StyledTableCell>
                    <StyledTableCell className='desc'>{row.description}</StyledTableCell>
                    <StyledTableCell align="right">{row.duration} min</StyledTableCell>
                  </StyledTableRow>                  
                  ));
                })()}
                    <StyledTableRow>
                      <StyledTableCellFooter colSpan={2} align="right">Total hours: </StyledTableCellFooter>
                      <TableCell align="right" sx={{ backgroundColor: "table.totalHighlight", fontWeight: 600, fontSize: 14, padding: "5px" }}>{totalHours}</TableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[50, 100, 250]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              />
            <br></br>
          </>
        );
};

export default TimelogTable;